import { render, staticRenderFns } from "./RightsList.vue?vue&type=template&id=0c436cf6&scoped=true&"
import script from "./RightsList.vue?vue&type=script&lang=js&"
export * from "./RightsList.vue?vue&type=script&lang=js&"
import style0 from "./RightsList.vue?vue&type=style&index=0&id=0c436cf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c436cf6",
  null
  
)

export default component.exports